'use client';

import { Component, FC, ReactNode } from 'react';

import { AxiosCartError, CartError } from '@telialt/models/src/EshopModel';

type Props = {
    ErrorComponent: FC<{ error: AxiosCartError | CartError | Error }>;
    additionalData?: any;
    children?: ReactNode;
};

type State = {
    hasError: boolean;
    error?: Error;
};

export default class ErrorBoundary extends Component<Props, State> {
    public readonly state: State = {
        hasError: false,
        error: undefined,
    };

    constructor(props: Props) {
        super(props);
    }

    public componentDidCatch(error: Error) {
        this.setState({ hasError: true, error });
    }

    public render() {
        const { ErrorComponent, children } = this.props;
        const { hasError, error } = this.state;

        if (hasError) {
            return <ErrorComponent error={error} />;
        }

        return children;
    }
}
